import autobind from "autobind-decorator";
import type { ReactNode } from "react";
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

interface Props<C extends React.ElementType> {
	as?: C;
	tooltip: ReactNode;
	className?: string;
	isDangerTooltip?: boolean;
	show?: boolean;
}

export class InfoPopup<C extends React.ElementType = "div"> extends React.Component<Props<C>> {
	public render(): ReactNode {
		const { children, className, as, show = undefined, tooltip = null } = this.props;
		const Component = as || "div";

		if (tooltip === null || tooltip === "") return <Component className={className}>{children}</Component>;

		return (
			<OverlayTrigger overlay={this.renderTooltip} show={show}>
				<Component className={className}>{children}</Component>
			</OverlayTrigger>
		);
	}

	@autobind
	private renderTooltip(props): ReactNode {
		const { tooltip, isDangerTooltip = false } = this.props;

		return (
			<Tooltip {...props} className={isDangerTooltip ? "tooltip-danger" : undefined}>
				{tooltip}
			</Tooltip>
		);
	}
}
